import React from 'react'

const animations = ['ca-cart-spin', 'ca-cart-pop', 'ca-cart-wiggle'] as const

type AnimationClass = (typeof animations)[number]

type Props = {
  className?: string
  children: React.ReactNode
  onAdd: () => void
}

const pickRandom = (): AnimationClass => {
  const idx = Math.floor(Math.random() * animations.length)
  return animations[idx]
}

const AddToCartButton: React.FC<Props> = ({ className, children, onAdd }) => {
  const [animClass, setAnimClass] = React.useState<AnimationClass | null>(null)
  const timeoutRef = React.useRef<number | null>(null)

  const animating = animClass !== null

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const handleClick = () => {
    if (animating) return

    onAdd()

    setAnimClass(pickRandom())
    timeoutRef.current = window.setTimeout(() => {
      setAnimClass(null)
      timeoutRef.current = null
    }, 1000)
  }

  return (
    <button
      type="button"
      disabled={animating}
      aria-busy={animating}
      onClick={handleClick}
      className={[
        className,
        animClass,
        animating ? 'opacity-85 cursor-not-allowed' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </button>
  )
}

export default AddToCartButton
